import { createBrowserHistory } from 'history'

export default createBrowserHistory({ basename: '/', keyLength: 15, forceRefresh: false })
